import React from 'react'
import { SvgIcon } from '@material-ui/core'

export default function NmkIcon() {
  return (
    <SvgIcon>
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        preserveAspectRatio="xMidYMid meet"
      >
<g>
	<path d="M13.14,7.76c0,0.06,0,0.11,0,0.15c0,1.37,0,2.74,0,4.11c0,0.24,0.02,0.49,0.06,0.73c0.3,1.58,1.2,2.7,2.71,3.25
		c1.51,0.55,2.92,0.27,4.17-0.75c0.16-0.13,0.3-0.28,0.44-0.43c-0.03-0.04-0.05-0.07-0.07-0.1c-0.85-1.09-1.14-2.32-0.85-3.67
		c0.24-1.12,0.87-2,1.81-2.65c0.05-0.03,0.12-0.08,0.13-0.13c0.02-0.17,0.01-0.34,0.01-0.51c-1.4,0-2.77,0-4.16,0
		c0,1.42,0,2.83,0,4.24c-0.02,0-0.04,0.01-0.06,0.01c-0.01-0.06-0.03-0.11-0.03-0.17c0-1.3,0-2.6,0-3.9c0-0.06-0.01-0.12-0.01-0.19
		C15.91,7.76,14.54,7.76,13.14,7.76z M7.58,14.79c-0.02-0.03-0.04-0.05-0.06-0.08c-0.94-1.25-1.17-2.61-0.7-4.1
		c0.03-0.11,0-0.15-0.08-0.2C5.57,9.64,4.4,8.87,3.23,8.09C3.14,8.03,3.07,8.03,2.97,8.07c-1.93,0.72-3.07,2.78-2.65,4.8
		c0.56,2.67,3.42,4.1,5.9,2.95C6.75,15.57,7.2,15.23,7.58,14.79z M10.86,7.8c-1.45-0.04-3.38,0.91-4,3.02
		c-0.59,2.01,0.36,4.13,2.23,5.02c1.83,0.87,3.89,0.28,4.97-1.02c-0.65-0.79-0.98-1.71-1.01-2.75c-0.07,0-0.13,0-0.19,0
		c-0.6,0-1.2,0-1.8,0c-0.14,0-0.19-0.03-0.19-0.19c0.01-1.3,0-2.6,0-3.9C10.86,7.92,10.86,7.86,10.86,7.8z M21.47,10.61
		c0-0.02,0-0.03,0-0.05c0.06-0.01,0.12-0.02,0.18-0.02c0.65,0,1.3,0,1.95,0c0.13,0,0.18-0.04,0.18-0.17c-0.01-0.81,0-1.62,0-2.42
		c0-0.05-0.01-0.1-0.01-0.17c-0.22,0.02-0.43,0.04-0.64,0.07c-2.82,0.46-4.39,3.6-3.04,6.13c0.76,1.41,1.96,2.16,3.57,2.27
		c0.12,0.01,0.13-0.05,0.13-0.14c0-0.83,0-1.65,0-2.48c0-0.04-0.01-0.08-0.01-0.15c-0.75,0-1.48,0-2.22,0
		c0.01-0.04,0.01-0.05,0.01-0.05c0.74,0,1.47,0,2.22,0c0-0.09,0.01-0.14,0.01-0.2c0-0.8,0-1.61,0-2.41c0-0.14-0.04-0.19-0.18-0.18
		 M7.2,9.78C7.14,9.74,7.1,9.7,7.05,9.67C6.16,9.09,5.27,8.5,4.39,7.92C4.2,7.79,3.94,7.78,3.72,7.9c1.11,0.73,2.21,1.46,3.32,2.19
		C7.1,9.97,7.15,9.88,7.2,9.78z M7.59,9.24C6.93,8.51,6.13,8.05,5.15,7.9c0.76,0.5,1.52,1,2.29,1.51C7.5,9.35,7.54,9.3,7.59,9.24z"
		/>
</g>      </svg>
    </SvgIcon>
  )
}
